import React, { Component } from "react";
import { connect } from "react-redux";
import { setNavbar } from "../actions/navbar";
import HomeImg from "../components/home/HomeImg";
import HomeTxt from "../components/home/HomeTxt";
import HomeLinks from "../components/home/HomeLinks";
import StyledHome from "../styles/StyledHome";

class Home extends Component {
  componentDidMount() {
    const { props: { setNavbarActn = (e) => console.log(e) } = {} } = this;

    return setNavbarActn("home");
  }

  render() {
    return (
      <StyledHome>
        <HomeImg />
        <div className="home-txt-container">
          <HomeTxt />
          <HomeLinks />
        </div>
      </StyledHome>
    );
  }
}

function mapStateToProps(state = {}) {
  const { navbar } = state;
  return { navbar };
}

export default connect(mapStateToProps, {
  setNavbarActn: setNavbar,
})(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js